<div class="main-delete">
  <div class="text-part">
    <span class="text-part-title">{{ 'delete_card_from_team.title' | translate }}</span>
    <span class="text-part-info">{{ 'delete_card_from_team.description' | translate }}</span>
  </div>
  <div class="action-part">
    <button class="option-cancel option-shared" (click)="cancel()">{{ 'delete_card_from_team.cancel' | translate }}</button>
    <button class="option-delete option-shared" (click)="deleteCardFromTeam()">{{ 'delete_card_from_team.delete_button' | translate }}</button>
  </div>
</div>
